export default ({ width = 40, height = 40 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="8" fill="#E5E7EB" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 30.3015C8 31.2396 8.76043 32 9.69846 32H30.3015C31.2396 32 32 31.2396 32 30.3015V9.69846C32 8.76043 31.2396 8 30.3015 8H9.69846C8.76043 8 8 8.76043 8 9.69846C8 10.0043 8.24797 10.2523 8.55385 10.2523C8.85973 10.2523 9.10769 10.0043 9.10769 9.69846C9.10769 9.37219 9.37219 9.10769 9.69846 9.10769H30.3015C30.6278 9.10769 30.8923 9.37219 30.8923 9.69846V30.3015C30.8923 30.6278 30.6278 30.8923 30.3015 30.8923H9.69846C9.37219 30.8923 9.10769 30.6278 9.10769 30.3015V15.4215C9.10769 15.1157 8.85973 14.8677 8.55385 14.8677C8.24797 14.8677 8 15.1157 8 15.4215V30.3015Z"
      fill="#1F2A37"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.0421 18.463C22.9382 18.5669 22.8799 18.7077 22.8799 18.8546V31.4454C22.8799 31.7513 23.1278 31.9992 23.4337 31.9992L30.3014 31.9992C31.2395 31.9992 31.9999 31.2388 31.9999 30.3008L31.9999 18.8546C31.9999 18.7077 31.9415 18.5669 31.8377 18.463C31.7338 18.3591 31.5929 18.3008 31.446 18.3008L28.0122 18.3008C27.7063 18.3008 27.4583 18.5487 27.4583 18.8546C27.4583 19.1605 27.7063 19.4085 28.0122 19.4085H30.8922L30.8922 30.3008C30.8922 30.6271 30.6277 30.8916 30.3014 30.8916H23.9876V19.4085H24.5783C24.8842 19.4085 25.1322 19.1605 25.1322 18.8546C25.1322 18.5487 24.8842 18.3008 24.5783 18.3008H23.4337C23.2868 18.3008 23.146 18.3591 23.0421 18.463Z"
      fill="#1F2A37"
    />
  </svg>
);
